import React from 'react';
import './ConvictionBand.css';
import { convictionLabel } from '../utils/convictionLabel';

const ConvictionBand = ({ band, score, size = 'medium' }) => {
  const normalizedBand = (band || 'Avoid').toLowerCase().replace(/\s+/g, '-');
  
  const bandConfig = {
    'high': { label: 'High Conviction', className: 'conviction-high' },
    'high-medium': { label: 'High-Medium', className: 'conviction-high-medium' },
    'medium': { label: 'Medium', className: 'conviction-medium' },
    'medium-low': { label: 'Medium-Low', className: 'conviction-medium-low' },
    'low': { label: 'Low', className: 'conviction-low' },
    'low-avoid': { label: 'Low-Avoid', className: 'conviction-low-avoid' },
    'avoid': { label: 'Avoid', className: 'conviction-avoid' },
  };

  const config = { ...(bandConfig[normalizedBand] || bandConfig.avoid) };
  // Show the label scale (Favorable ... Unfavorable), not the internal band word
  // ("High-Medium", "Avoid"): one vocabulary everywhere (2026-11-02). The band
  // still picks the color class.
  if (score !== undefined && score !== null && isFinite(score)) {
    config.label = convictionLabel(score);
  } else {
    config.label = { high: 'Favorable', 'high-medium': 'Promising', medium: 'Neutral',
      'medium-low': 'Cautious', low: 'Unfavorable' }[normalizedBand] || 'Unfavorable';
  }

  return (
    <div className={`conviction-band ${config.className} conviction-${size}`}>
      <div className="conviction-score">{score !== undefined ? Math.round(score) : '—'}</div>
      <div className="conviction-label">{config.label}</div>
    </div>
  );
};

export default ConvictionBand;
